import { managerialIsoDate } from '@/lib/managerial-calendar'

export function operatingCostMonthMax(): string {
  return `${Number(managerialIsoDate().slice(0, 4)) + 10}-12`
}

export function operatingCostMonthIndex(value: string): number | null {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(value)) return null
  if (value < '2000-01' || value > operatingCostMonthMax()) return null
  const [year, month] = value.split('-').map(Number)
  return year * 12 + month - 1
}

export function operatingCostMonthCount(start: string, end: string): number | null {
  const first = operatingCostMonthIndex(start)
  const last = operatingCostMonthIndex(end)
  return first === null || last === null || last < first ? null : last - first + 1
}

export function nextOperatingCostMonth(value?: string | null): string {
  const index = value ? operatingCostMonthIndex(value) : null
  if (index === null) return managerialIsoDate().slice(0, 7)
  const next = `${Math.floor((index + 1) / 12)}-${String(((index + 1) % 12) + 1).padStart(2, '0')}`
  return next > operatingCostMonthMax() ? value! : next
}
